import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export const initHeroSwiper = () => {
  let swiper = null;
  let hasInteracted = false;

  swiper = new Swiper('.hero__imageContainer', {
    loop: true,
    slidesPerView: 1,
    touchRatio: 2,
    touchAngle: 30,
    threshold: 5,
    speed: 500,
    navigation: {
      nextEl: '.hero--next.swiper-button-next',
      prevEl: '.hero--prev.swiper-button-prev',
      disabledClass: 'pointer-events-none opacity-0',
    },
    shortSwipes: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
      pauseOnLastSlide: false,
    },
    on: {
      init: function () {
        this.autoplay.stop();
      },
    },

    preventClicks: false,
    preventClicksPropagation: false,
  });

  const el = document.querySelector('.hero__imageContainer');

  const startAutoplayOnFirstInteraction = () => {
    if (hasInteracted) return;
    hasInteracted = true;
    swiper.autoplay.start();
    el.classList.remove('swiper-paused');

    const activeNavItem = el.querySelector('.swiper-pagination-bullet-active');
    if (activeNavItem) {
      activeNavItem.classList.remove('swiper-pagination-bullet-active');
      activeNavItem.classList.add('swiper-pagination-bullet-active');
      setTimeout(() => {
        activeNavItem.style.animation = '';
      }, 500);
    }
  };

  swiper.on('touchEnd', startAutoplayOnFirstInteraction);
  swiper.on('slideChange', startAutoplayOnFirstInteraction);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      const active = document.activeElement;
      if (active && active.tagName.toLowerCase() === 'a') {
        active.dispatchEvent(new MouseEvent('click', { bubbles: true }));
      }
    }
  });
};
